import { Pipe, PipeTransform } from '@angular/core';
import { CommentBase } from '@shared/api/api-loop/models/comment-base';
import { isMailComment } from '@dta/shared/models-api-loop/comment/comment.model';

@Pipe({
  name: 'isChannelComment',
  standalone: false
})
export class IsChannelCommentPipe implements PipeTransform {
  transform(comment: CommentBase): boolean {
    return isMailComment(comment) && !!comment.channelType;
  }
}
